// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-box[data-v-68142db0]{text-align:center;margin:60px 25px 25px 25px}.branded[data-v-68142db0]{background-color:#4abca5}.make-branded[data-v-68142db0]{color:grey}.bottom-bar[data-v-68142db0],.flex-d[data-v-68142db0]{background-color:#4abca5}.bottom-bar[data-v-68142db0]{border-top-style:solid;border-top-color:#837d89;border-top-width:5px}", ""]);
// Exports
module.exports = exports;
